import { cn } from "@/lib/utils";
import { AssigneeLoad, FOCUS_LIMIT, QUEUE_LIMIT } from "./priority-form-constants";

interface AssigneeLoadBadgeProps {
    load?: AssigneeLoad;
    className?: string;
}

/** Compact "Focus f/1 · Queue q/2" load indicator; a slot turns red when the user is at the limit. */
export function AssigneeLoadBadge({ load, className }: AssigneeLoadBadgeProps) {
    if (!load) return null;

    const focusFull = load.focus >= FOCUS_LIMIT;
    const queueFull = load.queue >= QUEUE_LIMIT;

    return (
        <span
            className={cn("inline-flex items-center gap-1 text-[10px] font-medium tabular-nums", className)}
            title={`Currently committed: ${load.focus}/${FOCUS_LIMIT} Focus, ${load.queue}/${QUEUE_LIMIT} Queue`}
        >
            <span className={cn("rounded px-1 py-0.5", focusFull ? "bg-destructive/10 text-destructive" : "bg-muted text-muted-foreground")}>
                Focus {load.focus}/{FOCUS_LIMIT}
            </span>
            <span className={cn("rounded px-1 py-0.5", queueFull ? "bg-destructive/10 text-destructive" : "bg-muted text-muted-foreground")}>
                Queue {load.queue}/{QUEUE_LIMIT}
            </span>
        </span>
    );
}
